module.exports = __webpack_public_path__ + "static/media/22-7.391a4e5a.mp3";